import { FilterModalType } from '../../components/app-components/filter-sort-section/types'
import FiltersState from './types'

const initialState: FiltersState = {
    filtersConfigurationResponse: null,
    committedFiltersConfigurationResponse: null,
    error: null,
    isLoading: false,
    isBlocking: false,
    currentOpenedFilterModal: FilterModalType.NONE, //
    regionNodeId: 0,
    lastDataPathEncoded: '',
    spaMode: false, // we can remove this after map migration
    isCancellationPolicyModalOpen: false,
    previousFilterModal: FilterModalType.NONE,
}

export default initialState
